module.exports = __webpack_public_path__ + "img/agency-black.beea519d.svg";